import has from 'lodash/has';
export const _has = has;
